import { asyncComponent } from 'react-async-loading';
import { Provider } from 'react-redux';

import { PureConnect, React, render } from '../react';

import READY from './actions/READY';
import SESSION_RESTORED from './actions/SESSION_RESTORED';

import selectors from './selectors';
import cx from './style.less';

const triggerSessionRestoredDelay = 300; // turns off animations during 'page load'

/* tslint:disable */
declare interface WebpackRequire extends NodeRequire {
  ensure(a: any[], b: (r: any) => any): any;
}
declare var require: WebpackRequire;
declare global {
  interface Console {
    timeStamp(name: string): void;
  }
}
/* tslint:enable */

export function RenderOutOfDate(target: Element) {
  const OutOfDate = asyncComponent(() => require.ensure([], () => require('./outOfDate')));

  const div = document.createElement('div');
  div.id = 'ls-userdata--browser-out-of-date';
  document.body.appendChild(div);

  render(<OutOfDate />, div);
}

const AppVisible = PureConnect(`AppVisible`)(
  (state) => ({ visible: selectors.visible(state) }),
  null,
  ({ visible, children }) => (visible ? children as any : null),
  // ({ visible, children }) => ( children as any ),
);

export function DefaultPlaceHolder() {
  if (!document.querySelector(`#ls-userdata,#ls-userdata-bar,#ls-userdata-app,#ls-userdata-note,#ls-userdata-askquestion`)) {
    const div = document.createElement('div');
    div.id = 'ls-userdata';
    div.setAttribute('role', 'complementary');
    div.innerHTML = `
<div id="ls-userdata-app" ></div>
<ul id="ls-userdata-bar" role="menubar" aria-label="functions">
  <li id="ls-userdata-note" role="menuitem" aria-label="Notitie gedeelte"></li>
  <li id="ls-userdata-quicknav" role="menuitem" aria-label="Snelle navigatie"></li>
</ul>
<div id="ls-userdata-ui"></div>
`;
    document.body.appendChild(div);
  }
}

export async function RenderApp(store: any) {
  const PropTypes = await import ('prop-types');
  const React = await import ('react');
  (React as any).PropTypes = PropTypes;  

  const NoteApp = asyncComponent(() => require.ensure([], () => require('../note/app')));
  const NoteBar = asyncComponent(() => require.ensure([], () => require('../note/bar')));
  const NoteUI = asyncComponent(() => require.ensure([], () => require('../note/ui')));
  
  await Promise.all([
    conditionalCss('#ls-userdata', cx('loading')),
    conditionalCss('#ls-userdata-bar'),
    conditional('Note App', '#ls-userdata-app', () => <AppVisible><NoteApp /></AppVisible>),
    conditional('Note Bar', '#ls-userdata-note', () => <AppVisible><NoteBar /></AppVisible>),
    conditional('Note UI', '#ls-userdata-ui', () => <AppVisible><NoteUI /></AppVisible>),
  ]).then(() => {
    store.dispatch(READY({}));
    setTimeout(async () => {
      await conditionalCss('#ls-userdata', cx('loaded'));
    });
    setTimeout(() => {
      store.dispatch(SESSION_RESTORED({}));
    }, triggerSessionRestoredDelay);
  }, (err: Error) => {
    // tslint:disable-next-line
    console.error(`[NoteService] Failed to load`, err);
  });

  // let isVisible = false;
  let isVisible = true;
  store.subscribe(() => {
    // TODO: middleware?
    const state = store.getState();
    const v = selectors.visible(state);
    if (isVisible !== v) {
      const bar = document.querySelector('#ls-userdata-bar') as HTMLElement;
      bar.style.display = v ? null : 'none';
      isVisible = v;
    }
    
    // for WCAG: not removing from dom
    const note = document.querySelector('#ls-userdata-bar') as HTMLElement;
    if (note.style.visibility!==(!state.admin.visible ? null : 'hidden'))
      note.style.visibility= !state.admin.visible ? null : 'hidden';
    const note2 = document.querySelector('#ls-userdata-note') as HTMLElement;
    if (note2.style.visibility!== (!state.admin.visible ? null : 'hidden'))
      note2.style.visibility= !state.admin.visible ? null : 'hidden';      

  });

  async function conditionalCss(target: string, additional?: string) {
    const el = document.querySelector(target);
    if (el) {
      el.className += ` ${cx(target.replace('#', ''))} ${additional || ''}`;
    }
  }
  async function conditional(name: string, target: string, content: () => React.ReactNode) {
    return await new Promise<void>((resolve, reject) => {

      const el = document.querySelector(target);
      if (el) {
        el.className += ' ' + cx(target.replace('#', ''), 'minireset');
        render(<Provider store={store}>{content()}</Provider>, el, () => resolve());
      } else {
        // tslint:disable-next-line
        console.warn(`[NoteService] Unable to place ${name}`);
        resolve();
      }
    });
  }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/browser/render.tsx